const DOCUMENT = 'AGENCY_VIEW_';

const actions = {
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  LOAD_REQUEST: DOCUMENT + 'LOAD_REQUEST',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  REMOVE_AGENCY_REQUEST: DOCUMENT + 'REMOVE_AGENCY_REQUEST',

  clearStore: () => ({ type: actions.CLEAR_STORE }),
  loadData: data => ({ type: actions.LOAD_REQUEST, payload: data }),
  loadDataSuccess: data => ({ type: actions.LOAD_SUCCESS, payload: data }),
  removeAgency: data => ({ type: actions.REMOVE_AGENCY_REQUEST, payload: data }),
};

export default actions;
